import React from 'react';

const CompanyLogoBox = ({ url, ...props }) => {
  return (
    <div className="p-[10px] rounded-[8px] shadow-md" {...props}>
      <img
        className="h-[40px] w-[150px] object-contain"
        alt="companyLogo"
        src={url}
      />
    </div>
  );
};

export default CompanyLogoBox;
